import { BoxShadow, IH2OTheme, Sizes } from '@h2oai/ui-kit';

export const IdpConnectionDetailsStyles = (theme: IH2OTheme) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  gap: '20px',
  padding: Sizes.padding,
  marginBottom: '1.5rem',
  backgroundColor: theme.palette?.white,
  borderRadius: Sizes.borderRadius,
  boxShadow: BoxShadow,
  color: theme.palette?.gray300,
});

export const infoLabelStyles = (theme: IH2OTheme) => ({
  fontWeight: 'bold',
  color: theme.palette?.gray600,
});

export const infoValueStyles = (theme: IH2OTheme) => ({
  fontFamily: "'Consolas', 'Monaco', 'Courier New', monospace",
  fontSize: '12px',
  backgroundColor: theme.palette?.gray200,
  color: theme.palette?.gray700,
  padding: '2px 6px',
  borderRadius: '4px',
  border: `1px solid ${theme.palette?.gray200}`,
  fontWeight: '500',
  width: 'fit-content',
});

export const overlayContainerStyles = () => ({
  position: 'absolute' as const,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  display: 'flex' as const,
  alignItems: 'center' as const,
  justifyContent: 'center' as const,
  zIndex: 2,
  flexDirection: 'column' as const,
  gap: '16px',
});
